export const AuthenticationType = Object.freeze({
  Basic: 'Basic',
  Facebook: 'Facebook',
  Google: 'Google',
});
